// export const BASE_API_URL = 'http://localhost:3220';
// export const BASE_API_URL = 'https://farserver.fearlessagainstrabies.com';
export const BASE_API_URL = 'https://farserver.imcdigital.in';
export default BASE_API_URL;